var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.videos),function(video,index){return _c('iframe',{key:index,attrs:{"src":'https://www.youtube.com/embed/' + video,"width":"100%","height":"auto","frameborder":"0","allow":"autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8b0ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/answers/Youtube/Youtube.vue
// module id = null
// module chunks = 